/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{c as r}from"../../chunks/vec3f64.js";import{projectBuffer as o}from"./projectBuffer.js";function t(r,t,f,e,n,s){return c[0]=r,c[1]=t,c[2]=f,o(c,e,0,n,s,0,1)}const c=r();export{t as projectXYZToVector};
